import { render, staticRenderFns } from "./NumberBadge.vue?vue&type=template&id=d3dfd360"
import script from "./NumberBadge.vue?vue&type=script&lang=js"
export * from "./NumberBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports